module.exports = __webpack_public_path__ + "media/images/background_graphics/trust_and_safety_background_vector_desktop-5b6421953f5e876d0bc7cac6f97e8e36.svg";